// @ts-ignore (fix me please, do not replicate)
import { CSSTransition, TransitionGroup } from "react-transition-group";

import Toast from "../../components/Toast";
import { ToastType, useToast } from "./ToastContext";

const TOAST_ICON_INFO = Object.freeze({
  [ToastType.Info]: {
    icon: "info",
    iconClasses: "text-default",
  },
  [ToastType.Warning]: {
    icon: "alert",
    iconClasses: "text-yellow",
  },
  [ToastType.Error]: {
    icon: "alert",
    iconClasses: "text-error",
  },
});
const TOAST_TRANSITION_TIMEOUT = 300; //ms

export function Toaster() {
  const { instances, dismiss } = useToast();
  return (
    <>
      <style global jsx>{`
        .toast-alert-enter {
          opacity: 0;
        }
        .toast-alert-enter-active {
          opacity: 1;
          transition: opacity 0.3s ease-in;
        }
        .toast-alert-exit {
          opacity: 1;
        }
        .toast-alert-exit-active {
          opacity: 0;
          transition: opacity 0.3s ease-in;
        }
      `}</style>
      <div className="fixed top-3 w-full z-overlay">
        <TransitionGroup>
          {instances.map((toast) => (
            <CSSTransition
              key={toast.id}
              timeout={TOAST_TRANSITION_TIMEOUT}
              classNames="toast-alert"
              unmountOnExit
            >
              <div className="container">
                <Toast
                  className="mt-sm bg-white"
                  key={toast.id}
                  icon={TOAST_ICON_INFO[toast.type].icon}
                  iconClasses={TOAST_ICON_INFO[toast.type].iconClasses}
                  message={toast.message}
                  onDismiss={() => dismiss(toast.id)}
                />
              </div>
            </CSSTransition>
          ))}
        </TransitionGroup>
      </div>
    </>
  );
}
